exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-subheader {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n}\nh2 {\n  max-width: 400px;\n}\n.mat-subheader {\n  margin-bottom: 0 !important;\n  padding-bottom: 0 !important;\n}\nli {\n  list-style: none;\n  margin-bottom: 5px;\n}\n.mat-empty,\n.mat-float,\n.mat-input-placeholder,\n.mat-input-placeholder,\n.mat-sidenav,\n.searchfield .mat-input-wrapper label,\nlabel {\n  color: #fff !important;\n}\nmd-input-container:not(.md-input-invalid).md-input-focused .md-input {\n  border-color: #fff !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/spot-list/spot-list.component.less
// module id = 389
// module chunks = 1